var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCamera(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25,
    height: 14.286,
    viewBox: "0 0 25 14.286",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Groupe_1149",
    "data-name": "Groupe 1149",
    transform: "translate(-923 6140.5)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icon_ionic-ios-videocam",
    "data-name": "Icon ionic-ios-videocam",
    transform: "translate(920.75 -6149.5)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1449",
    "data-name": "Trac\\xE9 1449",
    d: "M30.235,10.8a.953.953,0,0,0-.519.151L24.889,14a.477.477,0,0,0-.223.4V18.64a.477.477,0,0,0,.223.4l4.827,3.047a1,1,0,0,0,.519.151H31.4a.475.475,0,0,0,.48-.474V11.274a.479.479,0,0,0-.48-.474Z",
    transform: "translate(-4.625 -0.371)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1450",
    "data-name": "Trac\\xE9 1450",
    d: "M15.727,23.286H5.124A2.883,2.883,0,0,1,2.25,20.417V11.868A2.878,2.878,0,0,1,5.118,9h10.6a2.878,2.878,0,0,1,2.868,2.868v8.544A2.871,2.871,0,0,1,15.727,23.286Z",
    fill: "#fff"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCamera);
export default __webpack_public_path__ + "static/media/camera.3f533d89.svg";
export { ForwardRef as ReactComponent };